"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var time_1 = require("../../../common/helpers/time");
var observation_windows_1 = require("../../../common/helpers/observation-windows");
var CreateShiftModalInstanceController = /** @class */ (function () {
    function CreateShiftModalInstanceController($scope, $state, $uibModalInstance, BatchCreateService, FlashService, ToasterService) {
        var _this = this;
        this.$scope = $scope;
        this.$state = $state;
        this.$uibModalInstance = $uibModalInstance;
        this.BatchCreateService = BatchCreateService;
        this.FlashService = FlashService;
        this.ToasterService = ToasterService;
        this.updateEndDate = this.updateEndDate.bind(this);
        this.handleOpenSlotWindowChange =
            this.handleOpenSlotWindowChange.bind(this);
        this.drive = structuredClone(BatchCreateService.getDrive());
        this.drive.sectors = this.drive.sectors.filter(function (sector) {
            return !sector === false;
        });
        this.context = BatchCreateService.getContext();
        this.drives = [];
        this.today = new Date();
        this.endDate = structuredClone(this.drive).date;
        delete this.drive.notes; // remove notes for batches/shift
        this.drive.windowEnvelope = this.buildEnvelope(this.drive);
        this.drives.push(this.drive);
        this.datepicker = {
            open: function ($event) {
                _this.datepicker.status.opened = true;
            },
            dateOptions: {
                formatYear: "yy",
                startingDay: 7,
                showWeeks: false,
                minDate: this.drives[0].date,
            },
            format: "dd-MMMM-yyyy",
            status: {
                opened: false,
            },
        };
    }
    CreateShiftModalInstanceController.prototype.addDriveToShift = function () {
        var oldDrive = structuredClone(this.drives[this.drives.length - 1]);
        var newDrive = structuredClone(this.drives[this.drives.length - 1]);
        newDrive.time = (0, time_1.addMinutes)((0, time_1.addHours)(oldDrive.time, oldDrive.length.hours), oldDrive.length.minutes);
        // Keep the open-slot pattern at the same offset within the new session by
        // shifting it forward by the previous session's length.
        if (Array.isArray(newDrive.openSlots)) {
            var shiftMinutes_1 = Number(oldDrive.length.hours) * 60 + Number(oldDrive.length.minutes);
            newDrive.openSlots = newDrive.openSlots.map(function (slot) { return ({
                windowStart: (0, time_1.addMinutes)(slot.windowStart, shiftMinutes_1),
                windowEnd: (0, time_1.addMinutes)(slot.windowEnd, shiftMinutes_1),
                windowAdjusted: slot.windowAdjusted,
            }); });
        }
        newDrive.windowEnvelope = this.buildEnvelope(newDrive);
        this.drives.push(newDrive);
    };
    CreateShiftModalInstanceController.prototype.removeDriveFromShift = function ($index) {
        this.drives.splice($index, 1);
    };
    CreateShiftModalInstanceController.prototype.ok = function () {
        this.$uibModalInstance.close(this.$scope.selected.item);
    };
    CreateShiftModalInstanceController.prototype.cancel = function () {
        this.$uibModalInstance.dismiss("cancel");
    };
    /**
     * Prevents creating a shift with sessions that run into one another
     * @param index
     * @returns {*}
     */
    CreateShiftModalInstanceController.prototype.calculateMinTime = function (index) {
        var min;
        if (index === 0) {
            return;
        }
        min = (0, time_1.addMinutes)((0, time_1.addHours)(this.drives[index - 1].time, this.drives[index - 1].length.hours), this.drives[index - 1].length.minutes);
        if (index + 1 !== this.drives.length) {
            var max = this.drives[index + 1].time;
            var endTime = (0, time_1.addMinutes)((0, time_1.addHours)(this.drives[index].time, this.drives[index].length.hours), this.drives[index].length.minutes);
            var possibleMax = (0, time_1.subtractMinutes)((0, time_1.subtractHours)(this.drives[index + 1].time, this.drives[index + 1].length.hours), this.drives[index + 1].length.minutes);
            if ((0, time_1.isAfter)(endTime, max)) {
                this.drives[index].time = possibleMax;
            }
        }
        if ((0, time_1.isBefore)(this.drives[index].time, min)) {
            this.drives[index].time = min;
        }
        this.reflowSessionSlots(index);
    };
    CreateShiftModalInstanceController.prototype.updateEndDate = function (newDate) {
        this.endDate = newDate.selected[0];
    };
    /**
     * The session's scheduled time window, from its date/start time through its
     * length. Open slots must sit inside it.
     */
    CreateShiftModalInstanceController.prototype.buildEnvelope = function (drive) {
        var start = this.sessionStart(drive);
        return { start: start, end: (0, time_1.addMinutes)(start, this.sessionLength(drive)) };
    };
    CreateShiftModalInstanceController.prototype.sessionStart = function (drive) {
        var datePart = drive.date instanceof Date
            ? (0, time_1.toYMD)(drive.date)
            : (0, time_1.toYMD)((0, time_1.dateStringToDate)(drive.date));
        var timePart = (0, time_1.formatDateTime)(drive.time, "HH:mm:ss");
        return (0, time_1.dateTimeStringToDate)(datePart + " " + timePart);
    };
    CreateShiftModalInstanceController.prototype.sessionLength = function (drive) {
        return Number(drive.length.hours) * 60 + Number(drive.length.minutes);
    };
    /**
     * After a session's start time changes, shift its open slots by the same
     * delta so they keep their offset within the lesson, recompute the envelope,
     * and clamp the slots back inside it.
     */
    CreateShiftModalInstanceController.prototype.reflowSessionSlots = function (index) {
        var drive = this.drives[index];
        var previousStart = drive.windowEnvelope
            ? drive.windowEnvelope.start
            : this.sessionStart(drive);
        var envelope = this.buildEnvelope(drive);
        var delta = (0, time_1.differenceInMinutes)(envelope.start, previousStart);
        if (Array.isArray(drive.openSlots) && delta !== 0) {
            drive.openSlots = drive.openSlots.map(function (slot) { return ({
                windowStart: (0, time_1.addMinutes)(slot.windowStart, delta),
                windowEnd: (0, time_1.addMinutes)(slot.windowEnd, delta),
                windowAdjusted: slot.windowAdjusted,
            }); });
        }
        drive.windowEnvelope = envelope;
        if (Array.isArray(drive.openSlots)) {
            drive.openSlots.forEach(function (slot) {
                var clamped = (0, observation_windows_1.clampWindow)(slot.windowStart, slot.windowEnd, envelope.start, envelope.end);
                slot.windowStart = clamped.start;
                slot.windowEnd = clamped.end;
                slot.windowAdjusted = clamped.clamped;
            });
        }
    };
    CreateShiftModalInstanceController.prototype.addOpenSlot = function (sessionIndex) {
        var drive = this.drives[sessionIndex];
        if (!drive.openSlots) {
            drive.openSlots = [];
        }
        var existing = drive.openSlots.map(function (slot) { return ({
            start: slot.windowStart,
            end: slot.windowEnd,
        }); });
        var window = (0, observation_windows_1.nextAvailableWindow)(drive.windowEnvelope, existing);
        if (!window) {
            this.FlashService.setMessage({
                type: "error",
                message: "The session is fully covered by open slots. Shorten an existing slot to add another.",
            });
            return;
        }
        drive.openSlots.push({
            windowStart: window.start,
            windowEnd: window.end,
            windowAdjusted: false,
        });
    };
    CreateShiftModalInstanceController.prototype.removeOpenSlot = function (sessionIndex, slotIndex) {
        var drive = this.drives[sessionIndex];
        if (!drive.openSlots) {
            return;
        }
        drive.openSlots.splice(slotIndex, 1);
    };
    CreateShiftModalInstanceController.prototype.autoGenerateOpenSlots = function (sessionIndex) {
        var _a;
        var drive = this.drives[sessionIndex];
        var seats = ((_a = drive.vehicle) === null || _a === void 0 ? void 0 : _a.seats) || 0;
        if (seats < 1) {
            return;
        }
        var placeholders = Array.from({ length: seats }, function () { return ({}); });
        var windows = (0, observation_windows_1.equalSplitWindows)(drive.windowEnvelope.start, this.sessionLength(drive), placeholders);
        drive.openSlots = windows.map(function (window) { return ({
            windowStart: window.start,
            windowEnd: window.end,
            windowAdjusted: false,
        }); });
    };
    CreateShiftModalInstanceController.prototype.handleOpenSlotWindowChange = function (change) {
        var _a;
        // The picker name encodes which session the slot belongs to, e.g.
        // "openSlotStart_2"; change.index is the slot's position in that session.
        var _b = change.name.split("_"), field = _b[0], sessionPart = _b[1];
        var sessionIndex = Number(sessionPart);
        var drive = this.drives[sessionIndex];
        var slot = (_a = drive === null || drive === void 0 ? void 0 : drive.openSlots) === null || _a === void 0 ? void 0 : _a[change.index];
        if (!slot || !change.selected || change.selected.length === 0) {
            return;
        }
        var previousStart = slot.windowStart;
        var previousEnd = slot.windowEnd;
        var timeString = (0, time_1.formatDateTime)(change.selected[0], "HH:mm:ss");
        var chosen = (0, time_1.dateTimeStringToDate)((0, time_1.toYMD)(drive.windowEnvelope.start) + " " + timeString);
        var changed = field === "openSlotStart" ? "start" : "end";
        if (changed === "start") {
            slot.windowStart = chosen;
        }
        else {
            slot.windowEnd = chosen;
        }
        if (!slot.windowStart || !slot.windowEnd) {
            return;
        }
        var others = drive.openSlots
            .filter(function (_, index) { return index !== change.index; })
            .map(function (other) { return ({ start: other.windowStart, end: other.windowEnd }); });
        var snapped = (0, observation_windows_1.snapWindowToNeighbors)({ start: slot.windowStart, end: slot.windowEnd }, others, drive.windowEnvelope, changed);
        // A non-positive window means the edit landed past a neighbor with no room;
        // reject it and keep the slot where it was.
        if (snapped.end.getTime() <= snapped.start.getTime()) {
            slot.windowStart = previousStart;
            slot.windowEnd = previousEnd;
            slot.windowAdjusted = true;
            return;
        }
        slot.windowStart = snapped.start;
        slot.windowEnd = snapped.end;
        slot.windowAdjusted = snapped.adjusted;
    };
    CreateShiftModalInstanceController.prototype.createShift = function () {
        var _this = this;
        this.submitting = true;
        var endDate = (0, time_1.formatDateTime)(this.endDate, "YYYY-MM-DD");
        var template = structuredClone(this.drives[0]);
        var location = template.location;
        delete location.sectors;
        delete location.zoneparts;
        delete location.zones;
        var sectors = template.sectors.map(function (sector) {
            delete sector.geom;
            return {
                id: sector.id,
            };
        });
        var instructor = template.instructor;
        var vehicle = template.vehicle;
        var drives = structuredClone(this.drives).map(function (drive) {
            var time = drive.time;
            var date = drive.date;
            drive.date = (0, time_1.formatDateTime)(date, "YYYY-MM-DD");
            drive.formatDate = (0, time_1.formatDateTime)(date, "YYYY-MM-DD");
            drive.time = (0, time_1.formatDateTime)(time, "HH:mm");
            drive.formatTime = (0, time_1.formatDateTime)(time, "HH:mm");
            if (drive.observation === true && Array.isArray(drive.openSlots)) {
                drive.slots = drive.openSlots.map(function (slot) {
                    return (0, observation_windows_1.formatPivotWindow)({ start: slot.windowStart, end: slot.windowEnd });
                });
            }
            delete drive.openSlots;
            delete drive.windowEnvelope;
            delete drive.sectors;
            delete drive.instructor;
            delete drive.location;
            delete drive.vehicle;
            return drive;
        });
        this.BatchCreateService.getBatchMethod({
            drives: drives,
            end_date: endDate,
            days: this.days,
            sectors: sectors,
            instructor: instructor,
            location: location,
            vehicle: vehicle,
        }, this.context)
            .then(function (response) {
            _this.ToasterService.addToast({
                type: "success",
                message: response.message,
            });
            _this.BatchCreateService.setDrive(null);
            _this.$uibModalInstance.dismiss("cancel");
            _this.submitting = false;
            _this.$state.go("drivecoach.admin.calendar", {}, { reload: true });
        })
            .catch(function (Error) {
            _this.submitting = false;
        });
    };
    return CreateShiftModalInstanceController;
}());
CreateShiftModalInstanceController.$inject = [
    "$scope",
    "$state",
    "$uibModalInstance",
    "BatchCreateService",
    "FlashService",
    "ToasterService",
];
exports.default = CreateShiftModalInstanceController;
